// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.0
// source: order/orderItemStatus.enum.proto

/* eslint-disable */

export const protobufPackage = "orderItemStatus";

export enum EOrderItemStatus {
  UNKNOWN = 0,
  PENDING = 1,
  PREPARING = 2,
  COMPLETED = 3,
  CANCELLED = 4,
  UNRECOGNIZED = -1,
}

export function eOrderItemStatusFromJSON(object: any): EOrderItemStatus {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return EOrderItemStatus.UNKNOWN;
    case 1:
    case "PENDING":
      return EOrderItemStatus.PENDING;
    case 2:
    case "PREPARING":
      return EOrderItemStatus.PREPARING;
    case 3:
    case "COMPLETED":
      return EOrderItemStatus.COMPLETED;
    case 4:
    case "CANCELLED":
      return EOrderItemStatus.CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EOrderItemStatus.UNRECOGNIZED;
  }
}

export function eOrderItemStatusToJSON(object: EOrderItemStatus): string {
  switch (object) {
    case EOrderItemStatus.UNKNOWN:
      return "UNKNOWN";
    case EOrderItemStatus.PENDING:
      return "PENDING";
    case EOrderItemStatus.PREPARING:
      return "PREPARING";
    case EOrderItemStatus.COMPLETED:
      return "COMPLETED";
    case EOrderItemStatus.CANCELLED:
      return "CANCELLED";
    case EOrderItemStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
